import { CustomButton, CustomCheckbox } from '@/shared/ui/components';
import { Modal } from 'antd';
import classNames from 'classnames';
import { t } from 'ttag';
import { useProtectPlusDeviceModal } from './useProtectPlusDeviceModal';
import type { ProtectPlusDeviceModalProps } from './protectPlusDeviceModal.types';
import './protectPlusDeviceModal.scss';

const ProtectPlusDeviceModal = ({
  isOpen,
  onClickCancelButton,
  onClickConfirmButton,
}: ProtectPlusDeviceModalProps) => {
  const { state, onChange } = useProtectPlusDeviceModal({ isOpen });

  return (
    <Modal
      className="protect-plus-modal"
      open={isOpen}
      centered
      footer={null}
      closeIcon={null}
      width={400}
      title={t`Maintenance needed`}
      classNames={{ header: 'header' }}
    >
      <div>
        <div className="content">
          {t`This device requires maintenance to improve performance. Please initiate an RMA ticket so the device can be sent back to Biotricity for inspection.`}
        </div>
        <div className="checkbox-wrap">
          <CustomCheckbox
            id="maintenance-needed-confirm"
            {...({ name: 'isUnderstood' } as any)}
            checked={state.isUnderstood}
            onChange={onChange}
            label={t`I understand this device may or may not be performing optimally.`}
          />
        </div>
      </div>
      <div className="footer">
        <CustomButton
          type="outline"
          style="neutral"
          id="cancel-protect-plus-device-btn"
          onClick={onClickCancelButton}
        >
          {t`Cancel`}
        </CustomButton>
        <CustomButton
          style="default"
          type="primary"
          id="use-this-device-btn"
          className={classNames(!state.isUnderstood ? 'custom-disabled' : '')}
          disabled={!state.isUnderstood}
          onClick={onClickConfirmButton}
        >
          {t`Use This Device`}
        </CustomButton>
      </div>
    </Modal>
  );
};

export default ProtectPlusDeviceModal;
